import { forwardRef, useEffect, useState } from "react";

const SelfViewContainer = forwardRef(({
  noRenderizarParticipanteLocal,
  esLayoutMobile,
  deberiaEstarEnSalaEspera,
  videoLayout,
  visibleParticipants,
  canvasDimension,
  participanteLocal,
}, ref) => {

  const [selfVideoLayout, setSelfVideoLayout] = useState(null);
  useEffect(() => {
    const currentUserIndex = visibleParticipants.findIndex(
      (user) => user.userId === participanteLocal?.userId,
    );
    if (currentUserIndex > -1) {
      const item = videoLayout[currentUserIndex];
      if (item && canvasDimension) {
        setSelfVideoLayout({
          ...item,
        });
      } else {
        setSelfVideoLayout(null);
      }
    }
  }, [
    canvasDimension,
    participanteLocal?.userId,
    videoLayout,
    visibleParticipants
  ]);


  return (
    <video-player-container
      style={(!selfVideoLayout || noRenderizarParticipanteLocal) ?
        {
          display: "none",
        } : {
          zIndex: 7,
          position: "absolute",
          display: "block",
          width: `${selfVideoLayout.width}px`,
          height: `${selfVideoLayout.height}px`,
          top:
            esLayoutMobile && deberiaEstarEnSalaEspera
              ? `${selfVideoLayout.y + 70}px`
              : `${selfVideoLayout.y}px`,
          left: `${selfVideoLayout.x}px`,
          pointerEvents: "none",
        }}
      ref={ref}
    />
  );
});

export default SelfViewContainer;
